// extracted by mini-css-extract-plugin
export var cartIcon = "_p6-0";
export var cartIconContainer = "_p6-1";